// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var FreeProductInput = /* #__PURE__ */ (function () {
    function FreeProductInput(value0) {
        this.value0 = value0;
    };
    FreeProductInput.create = function (value0) {
        return new FreeProductInput(value0);
    };
    return FreeProductInput;
})();
var NoInput = /* #__PURE__ */ (function () {
    function NoInput() {

    };
    NoInput.value = new NoInput();
    return NoInput;
})();
var ProductReference = function (x) {
    return x;
};
var PromotionalItem = function (x) {
    return x;
};
var newtypePromotionalItem_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductReference_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPromotionalItem = function (dictHasField) {
    return dictHasField;
};
var hasFieldProductReference = function (dictHasField) {
    return dictHasField;
};
var eqPromotionalItemInput = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FreeProductInput && y instanceof FreeProductInput) {
                return x.value0.selection === y.value0.selection;
            };
            if (x instanceof NoInput && y instanceof NoInput) {
                return true;
            };
            return false;
        };
    }
};
var eqProductReference = {
    eq: function (x) {
        return function (y) {
            return x.productGroupIndex === y.productGroupIndex && x.productSequenceNum === y.productSequenceNum;
        };
    }
};
var eqPromotionalItem = {
    eq: function (x) {
        return function (y) {
            return x.active === y.active && Data_Eq.eq(Data_Maybe.eqMaybe(eqProductReference))(x.assignment)(y.assignment) && Data_Eq.eq(eqPromotionalItemInput)(x.input)(y.input) && Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(x.promotionId)(y.promotionId) && x.promotionalItemId === y.promotionalItemId && Data_Eq.eq(Data_Eq.eqArray(eqProductReference))(x.source)(y.source) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney))(x.value)(y.value);
        };
    }
};
var genericPromotionalItemInput = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new FreeProductInput(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return NoInput.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types.PromotionalItem (line 17, column 1 - line 17, column 95): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FreeProductInput) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NoInput) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Promotions.Types.PromotionalItem (line 17, column 1 - line 17, column 95): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemInput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionalItemInput)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "selection";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NoInput";
        }
    })))
};
var unscrambleDecodePromotionalItemInput = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionalItemInput)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "selection";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "NoInput";
        }
    }))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericProductReference = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductReference = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductReference)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "ProductReference";
        }
    }))
};
var showPromotionalItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionalItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "active";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionalItemId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(/* #__PURE__ */ Data_Show.showArray(showProductReference)))(Data_Show.showInt))(Restaumatic_Promotions_Types_Id.showPromotionId))(showPromotionalItemInput))(/* #__PURE__ */ Data_Maybe.showMaybe(showProductReference)))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "PromotionalItem";
        }
    }))
};
var unscrambleDecodeProductReference = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductReference)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePromotionalItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionalItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "active";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(unscrambleDecodeProductReference))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "input";
        }
    })(unscrambleDecodePromotionalItemInput)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionalItemId";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeProductReference))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Money_Rounded.udecodeMoney))(Unscramble.decodeRecordNil)))))))))))(Unscramble_Generic.defaultOptions)
};
var encodePromotionalItemInput = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "NoInput";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))
};
var encodeProductReference = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductReference";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))
};
var encodePromotionalItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PromotionalItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Money_Rounded.encodeMoney))))({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeProductReference))))({
        reflectSymbol: function () {
            return "promotionalItemId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionalItemInput)))({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(encodeProductReference))))({
        reflectSymbol: function () {
            return "active";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))
};
var decodePromotionalItemInput = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "NoInput";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))
};
var decodeProductReference = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductReference)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductReference";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "productSequenceNum";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "productGroupIndex";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePromotionalItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionalItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PromotionalItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Money_Rounded.decodeMoney)))())({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeProductReference)))())({
        reflectSymbol: function () {
            return "promotionalItemId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())({
        reflectSymbol: function () {
            return "input";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionalItemInput))())({
        reflectSymbol: function () {
            return "assignment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(decodeProductReference)))())({
        reflectSymbol: function () {
            return "active";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    FreeProductInput,
    NoInput,
    PromotionalItem,
    ProductReference,
    genericPromotionalItemInput,
    eqPromotionalItemInput,
    showPromotionalItemInput,
    encodePromotionalItemInput,
    decodePromotionalItemInput,
    unscrambleDecodePromotionalItemInput,
    genericPromotionalItem,
    eqPromotionalItem,
    showPromotionalItem,
    encodePromotionalItem,
    decodePromotionalItem,
    unscrambleDecodePromotionalItem,
    hasFieldPromotionalItem,
    newtypePromotionalItem_,
    genericProductReference,
    eqProductReference,
    showProductReference,
    encodeProductReference,
    decodeProductReference,
    unscrambleDecodeProductReference,
    hasFieldProductReference,
    newtypeProductReference_
};
//# sourceMappingURL=index.js.map
